<template>
  <v-container
    id="about"
    tag="section"
  >
    <base-subheading><h1 class="text-center mt-5" style="font-family: 'Montserrat Subrayada', sans-serif;">OZNAKOWANIA POZIOME</h1></base-subheading>
    <v-col cols="10" offset-md="1">

      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Zajmujemy się profesjonalnym i funkcjonalnym zorganizowaniem, zaprojektowaniem oraz wykonaniem oznakowania poziomego na terenie nowego, bądź istniejącego obiektu zgodnie z wymogami Państwowej Inspekcji Pracy. 
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Proponujemy fachowe doradztwo w zakresie oznakowania poziomego oraz zabezpieczania posadzek przemysłowych. Posiadamy odpowiednią wiedzę, umiejętności, nowoczesny sprzęt, przeszkolonych ludzi oraz przede wszystkim doświadczenie w malowaniu oznakowań poziomych. Oferujemy:
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        <ul>
          <li>oznakowanie poziome</li>
            <ul>
              <li>magazynu i zakładu produkcyjnego</li>
              <li>boisk sportowych</li>
              <li>parkingów</li>
            </ul>
          <li>oznakowanie cienkowarstwowe</li>
          <li>oznakowanie grubowarstwowe</li>
          <li>usuwanie oznakowania poziomego</li>
          <li>montaż barierek oraz luster magazynowych</li>
        </ul>
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Malowanie linii w obiekcie wymaga odpowiedniego podejścia oraz poświęcenia czasu, ponieważ nowe oznakowanie poziome powinno spełniać szereg funkcji np. w ruchu wózków widłowych, innnych pojazdów oraz pieszych. Właściwe oznakowanie dróg, zewnętrznych terenów zakładowych, bądź  parkingów ma bezpośrednie znaczenie na bezpieczeństwo oraz zapobieganie wypadkom. Jeżeli chcemy zapewnić bezpieczeństwo użytkownikom drogi, strefy ruchu w zakładach, magazynach, tereny zewnętrzne,  parkingi, wszystkie obszary, na których odbywa się ruch kołowy, powinny  posiadać odpowiednie oznakowanie wykonane przy użyciu odpowiednich technologii.
      </p>
      
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        <base-subheading><h1 class="text-center mt-5" style="font-family: 'Montserrat Subrayada', sans-serif;">ZNAKUJEMY</h1></base-subheading>
        <ul>
          <li>drogi transportowe dla wózków widłowych</li>
          <li>ścieżki oraz przejścia dla pieszych</li>
          <li>pola odkładcze</li>
          <li>linie segregacyjne</li>
          <li>linie w regałach</li>
          <li>rampy załadunkowe</li>
          <li>słupy</li>
          <li>naroża</li>
          <li>skrajnie</li>
          <li>strefy niebezpieczne oraz wyłączone</li>
          <li>koperty</li>
        </ul>
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Prawidłowe oznakowanie poziome hali magazynowej zapewnia porządek, zwiększa wydajność, poczucie bezpieczeństwa pracowników, zwiększa zasoby i wpływa na wizerunek zewnętrzny firmy. Wpływa również  na optymalne wykorzystanie przestrzeni hali magazynowej oraz ułatwia prowadzenie inspekcji i kontroli jakości. Współczesne firmy mają, więc wystarczającą ilość powodów, żeby dbać o dobre oznakowanie poziome magazynów.
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Malujemy linie parkingowe na terenach przyzakładowych oraz zewnętrznych, np. parking galerii handlowej bądź supermarketów. Linie parkingowe, miejsca dla niepełnosprawnych, miejsca dla rodzin z dziećmi, strzałki,  znaki poziome itp. Znakujemy również garaże podziemne (numeracja,  oznakowanie pionowe, przejścia dla pieszych, strzałki, słupy, skrajnie). 
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Specjalistyczny sprzęt oraz umiejętności, pozwalają nam w sposób profesjonalny przygotować obiekty sportowe pod względem oznakowania powierzchni. Stosujemy nowoczesne technologie oraz sprawdzone produkty, aby linie służyły bez zastrzeżeń. Współpracujemy ze szkołami oraz urzędami gmin, zajmujemy się również kompleksowymi renowacjami boisk sportowych.
      </p>
      <p class="text-right font-weight-light" style="font-family:Montserrat"><i>Design, Perfection & Quality ™</i></p>

    </v-col>

  </v-container>
</template>

<script>
  export default {
    name: 'HomeAbout',
  }
</script>
